import React, { useEffect, useRef, useState } from 'react';
import ImprimirEtiquetasCodigosDialog from '../compras/ImprimirEtiquetasCodigosDialog';
import PDFViewer from '../shared/PDFViewer';
import productoService from '../../services/productoService';

export interface ImprimirEtiquetasProductoHostProps {
  open: boolean;
  codigoArticulo: string;
  descripcion?: string | null;
  onClose: () => void;
}

const ImprimirEtiquetasProductoHost: React.FC<ImprimirEtiquetasProductoHostProps> = ({
  open,
  codigoArticulo,
  descripcion,
  onClose,
}) => {
  const [pdf, setPdf] = useState<{ url: string; fileName: string } | null>(null);
  const pdfRef = useRef<{ url: string; fileName: string } | null>(null);

  useEffect(() => {
    pdfRef.current = pdf;
  }, [pdf]);

  useEffect(() => {
    return () => {
      const prev = pdfRef.current;
      if (prev?.url) URL.revokeObjectURL(prev.url);
    };
  }, []);

  const codigo = (codigoArticulo || '').trim();
  if (!codigo) return null;

  return (
    <>
      <ImprimirEtiquetasCodigosDialog
        open={open}
        nroFormulario={0}
        detalles={[
          {
            codigoArticulo: codigo,
            descripcionArticulo: (descripcion || '').trim() || codigo,
            cantidad: 1,
          },
        ]}
        textoOrigen="este producto"
        fileName={`etiquetas-${codigo}.pdf`}
        obtenerPdf={async (_id, items, idCompania) => {
          const item = items[0];
          return productoService.getEtiquetaPdf(item.codigoArticulo, item.copias, idCompania);
        }}
        onClose={onClose}
        onPdfReady={(url, fileName) => {
          setPdf((prev) => {
            if (prev?.url) URL.revokeObjectURL(prev.url);
            return { url, fileName };
          });
        }}
      />
      {pdf ? (
        <PDFViewer
          pdfUrl={pdf.url}
          title={`Etiquetas ${codigo}`}
          documentId={codigo}
          documentType="informeCliente"
          downloadFileName={pdf.fileName}
          onClose={() => {
            URL.revokeObjectURL(pdf.url);
            setPdf(null);
          }}
        />
      ) : null}
    </>
  );
};

export default ImprimirEtiquetasProductoHost;
